import React, { Component } from 'react';
import $ from "jquery";
import logo from "../logo.png";

class Header extends Component {

    menu() {
        $(".navbar-burger").toggleClass("is-active");
        $(".navbar-menu").toggleClass("is-active");
    }
    
    render() {
        return (
            <nav className="navbar header" role="navigation" aria-label="main navigation">
                <div className="navbar-brand">
                    <a className="navbar-item">
                        <img src={logo}/>
                    </a>
                    <a role="button" className="navbar-burger burger" aria-label="menu" aria-expanded="false" onClick={this.menu}>
                        <span></span>
                        <span></span>
                        <span></span>
                    </a>
                </div>
                <div className="navbar-menu">
                    <div className="navbar-end">
                        <div className="navbar-item has-dropdown is-hoverable">
                            <a className="navbar-link settings">
                                Instellingen
                            </a>
                            <div className="navbar-dropdown is-right">
                                <a className="navbar-item" onClick={(e) => this.props.setPage("saloncode")}>
                                    Saloncode
                                </a>
                                <a className="navbar-item" onClick={(e) => this.props.setPage("salons")}>
                                    Salons
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </nav>
        );
    }
}

export default Header;